import { useState } from "react";

const useForceUpdate = () => {
  // eslint-disable-next-line react/hook-use-state
  const [, setValue] = useState(0);

  return () => setValue(value => value + 1);
};

export default useForceUpdate;
